export const reconciliationOptions = {
  BOOKING_COMPLETED: 'completedAt',
  STUDENT_CHECK_IN: 'finalMoveInDate',
  STUDENT_CHECK_OUT: 'finalMoveOut',
};

export const orderInstalmentPlanType = {
  FULL_PAYMENT: 'FULL_PAYMENT',
  PAY_QUARTERLY: 'PAY_QUARTERLY',
  PAY_MONTHLY: 'PAY_MONTHLY',
  PAY_WEEKLY: 'PAY_WEEKLY',
  PAY_REMAINDER_AT_ONCE: 'PAY_REMAINDER_AT_ONCE',
};

export const orderCounterOfferDiscountType = {
  PERCENTAGE: 'PERCENTAGE',
  ABSOLUTE: 'ABSOLUTE',
};
